import { CommonPaginator, usePaginated } from './usePaginated'
import { Customer } from 'depoto-core'
import { useCallback, useMemo } from 'react'
import { removeEmptyProperties } from '../'
import { useCore } from '../../hooks'

export type CustomerFilters = Partial<{
  externalId: string
  email: string
  fulltext: string
  companies: number[]
  user: number
  checkouts: number[]
  priceLevel: number
  tags: number[]
}>

interface Params {
  filters?: CustomerFilters
  sort?: string
  direction?: string
  schema?: any
}

export function usePaginatedCustomers(params: Params = {}) {
  const { filters, schema = { id: null }, sort = 'firstName', direction = 'ASC' } = params
  const { core } = useCore()

  const serverFilters = useMemo(
    () =>
      removeEmptyProperties(filters || {}),
    [filters],
  )

  const fetchCustomers = useCallback(
    async (page: number) => {
      const params: any = removeEmptyProperties({
        direction,
        filters: serverFilters,
        page,
        sort: sort,
      })

      return (await core.services.customer.getList(params, schema)) as {
        items: Customer[]
        paginator: CommonPaginator
      }
    },
    [core.services.customer, serverFilters, sort],
  )

  const {
    isLastPage,
    loadMore,
    loading,
    refresh,
    items: customers,
    totalCount,
  } = usePaginated<Customer>({
    queryKey: ['customers', filters, sort, direction],
    fetchItems: fetchCustomers,
  })

  return {
    isLastPage,
    loadMore,
    loading,
    customers,
    refresh,
    totalCount,
  }
}
